export const penalties: TableModule = {
    name: "penalties",
    route: "spa.sportsManagement.gameDays.penalties",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    routeParams: [{
        param: "gameDay",
        prop: "game_day_id"
    }, {
        param: "game",
        prop: "game_id"
    }],
    columns: [
        {
            name: "penaltyFor",
            pageLink: true,
            mobile: true,
            sortable: true,
            sortBy: "organisations.name|teams.name"
        }, {
            name: "name",
        }, {
            name: "price",
            breakpoint: "md"
        }, {
            name: "createdByUser",
        }, {
            name: "comment"
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "penalties"]
        }
    ]
}